import React, { useMemo } from 'react';
import { BasicInfoCollapse } from '../../../../../../components';
import { returnPowerState } from '../../../../helpers';

export const BasicVMInfo = ({ record }) => {
    const infoItems = useMemo(
        () => [
            { label: 'ID', value: record?.id, copyable: true },
            { label: 'Host/IP', value: record?.ip_addresses[0] || record?.host, copyable: true },
            { label: 'Host Name', value: record?.host_name || 'N/A', copyable: true },
            { label: 'Reported OS', value: record?.reported_os_version || '', tooltipThreshold: 30 },
            { label: 'Configured OS', value: record?.configured_os_version || '', tooltipThreshold: 30 },
            { label: 'Power State', value: returnPowerState(record) },
        ],
        [record],
    );

    return <BasicInfoCollapse title={record?.name} infoItems={infoItems} />;
};
